import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";

import { SharedModule } from '@shared/shared.module';

import { environment } from '@env/environment';

const baseUrl = `${environment.apiBaseUrl}platform/developerscorecard`;
const exportUrl = `${environment.apiBaseUrl}platform/export`;


@Injectable({
  providedIn: SharedModule
})
export class DeveloperScorecardService {

  constructor(private http: HttpClient) { }

  searchByValues: any;
  get(id: string): Observable<Scorecard.ScorecardModel> {
    return this.http.get<Scorecard.ScorecardModel>(`${baseUrl}/${id}/scorecard`);
  }

  getResult(developerId: string, type: string, date?: any,searchByValues?: any): Observable<any> {
    const headers = new HttpHeaders({
      'x-no-notification': 'true'
    });

    const body: any = {
      scoreCardWidgetType: type,
    };

    if (type === 'CODE_QUALITY_OPEN_ISSUES_HISTORICAL_VIEW_SCORE_CARD') {
      body.searchByValues = searchByValues;
    }

    let params = new HttpParams();

    if (date && date.fromDate) {
      params = params.append('fromDate', date.fromDate);
      params = params.append('toDate', date.toDate);
    }
    if (date && !date.fromDate) {
      params = params.append('fromDate', date);
    }

    return this.http.post<any>(`${baseUrl}/${developerId}/scorecard`, body, {headers, params});
  }

  getReport(id: string): Observable<Scorecard.ReportModel> {
    return this.http.get<Scorecard.ReportModel>(`${baseUrl}/${id}/report/settings`);
  }

  createReport(id: string, report: Scorecard.Report): Observable<Scorecard.Report> {
    return this.http.post<Scorecard.Report>(`${baseUrl}/${id}/report/settings`, report);
  }

  updateReport(id: string, report: Scorecard.Report): Observable<Scorecard.Report> {
    return this.http.put<Scorecard.Report>(`${baseUrl}/${id}/report/settings`, report);
  }

  downloadExportDeveloperData(id) : Observable<HttpResponse<Blob>>{
    return this.http.get(`${exportUrl}/${id}`, { responseType: 'blob', observe: 'response' });
  }


  deleteDownloadExportDeveloperData(id): Observable<any> {
    return this.http.delete(`${exportUrl}/${id}`);
  }

  getExportDataListByDeveloper(developerId: string, metricType?: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('developerId', developerId);
    params = params.append('metricType', metricType);
    return this.http.get(`${exportUrl}`, {params});
  }

  exportDeveloper(developerId: string, date?: any, metricType?: string, sorting?: any, searchByValues?: any): Observable<any> {
    const payload = {
      developerId,
      metricType,
      type: "EXCEL",
      from: '',
      to: '',
      sorting,
      searchByValues: this.searchByValues
    };
    if (date && date.fromDate) {
      payload.from = date.fromDate;
      payload.to = date.toDate;
    }

    if (date && !date.fromDate) {
      payload.from = date;
    }
    return this.http.post(`${exportUrl}`, payload);
  }

  getCommitWithSorting(developerId: string, type: string, date: any, page: any, searchByValues: any, pageSize: any, sorting: any): Observable<any> {
    this.searchByValues = searchByValues;

    const body = {
      developerId,
      scoreCardWidgetType: type,
      page,
      searchByValues,
      pageSize,
      sorting,
    };

    const headers = new HttpHeaders({
      'x-no-notification': 'true'
    });

    let params = new HttpParams();

    if (date && date.fromDate) {
      params = params.append('fromDate', date.fromDate);
      params = params.append('toDate', date.toDate);
    }

    if (date && !date.fromDate) {
      params = params.append('fromDate', date);
    }

    return this.http.post<Developer.DeveloperModel[]>(`${baseUrl}/${developerId}/scorecard`, body, { headers, params });
  }

}
